import { render, staticRenderFns } from "./VisualizarRespostaFormulario.vue?vue&type=template&id=3b1021bc&scoped=true&"
import script from "./VisualizarRespostaFormulario.vue?vue&type=script&lang=js&"
export * from "./VisualizarRespostaFormulario.vue?vue&type=script&lang=js&"
import style0 from "./VisualizarRespostaFormulario.vue?vue&type=style&index=0&id=3b1021bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1021bc",
  null
  
)

export default component.exports